module.exports = __webpack_public_path__ + "static/media/logo-expodireto.fef0a312.png";